"use strict";

exports.__esModule = true;
exports.ElementClipboardControlGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Shows a group of controls for copying, cutting and pasting elements.
 */
var ElementClipboardControlGroup = exports.ElementClipboardControlGroup = /*#__PURE__*/function (_Component) {
  function ElementClipboardControlGroup() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementClipboardControlGroup, _Component);
  var _proto = ElementClipboardControlGroup.prototype;
  _proto.render = function render() {
    var elementEditor = this.props.elementEditor;
    var selectedPath = elementEditor.selectedPath;
    return /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      large: true,
      minimal: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.DUPLICATE,
      disabled: selectedPath.length === 0,
      onClick: elementEditor.copyElement
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.CUT,
      onClick: elementEditor.cutElement
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.CLIPBOARD,
      onClick: elementEditor.pasteElement
    }));
  };
  return ElementClipboardControlGroup;
}(_react.Component);